export default "<a  class=\"layout-topbar-logo\">\n    <img id=\"topbar-logo\" [src]=\"siteLogo | safe\">\n</a> ";